import {
  DOCUMENT,
  EnvironmentProviders,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  Provider,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAllianzIcons } from '@allianz/ngx-brand-kit/icon';
import { NxIsoDateModule } from '@allianz/ng-aquila/iso-date-adapter';
import { ERROR_DEFAULT_OPTIONS } from '@allianz/ng-aquila/base';
import { FORMFIELD_DEFAULT_OPTIONS } from '@allianz/ng-aquila/formfield';
import { NX_DATE_LOCALE } from '@allianz/ng-aquila/datefield';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import dayjs from 'dayjs';
import { santanderRoutes } from './routes';
import { AppConfigModel, provideAppConfig } from '@retail-portal-santander-frontend/app-config';
import { BASE_PATH } from '@retail-portal-santander-frontend/generated-api';
import {
  authInterceptor,
  errorInterceptor,
  getCookieValue,
  withCredentialsInterceptor,
} from '@retail-portal-santander-frontend/shell-utils';
import { PAYMENT_URL } from '@retail-portal-santander-frontend/shared-data-access';
import { WINDOW } from '@retail-portal-santander-frontend/shared-utils';
import { NxMessageToastService } from '@allianz/ng-aquila/message';
import 'dayjs/locale/en-gb';
import { provideLogger } from './providers/logger.provider';

registerLocaleData(en);
dayjs.locale('en-GB');

export function provideCore(config: AppConfigModel): (EnvironmentProviders | Provider)[] {
  return [
    provideAppConfig(config),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(santanderRoutes, withHashLocation(), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withInterceptors([authInterceptor, withCredentialsInterceptor, errorInterceptor])),
    provideAnimations(),
    provideAllianzIcons(),
    importProvidersFrom(NxIsoDateModule),
    provideLogger(config),
    NxMessageToastService,
    {
      provide: ERROR_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'text',
      },
    },
    {
      provide: FORMFIELD_DEFAULT_OPTIONS,
      useValue: {
        nxFloatLabel: 'always',
      },
    },
    { provide: NX_DATE_LOCALE, useValue: 'en-GB' },
    { provide: BASE_PATH, useValue: config.baseURL },
    { provide: PAYMENT_URL, useValue: config.paymentUrl },
    provideAppInitializer(() => {
      const document = inject(DOCUMENT);
      const window = inject(WINDOW);

      const token = getCookieValue(document.cookie, 'access_token') || '';

      if (!token) {
        window.location = config.metaportalUrl;
      }
    }),
  ];
}
